module.exports = "<div class=\"loader-outer\">\n  <div class=\"loader loader-content\">\n    <div class=\"hd-txt\">{{currentAnimationTxt}}</div>\n    <img src = \"{{currentAnimation}}\" class=\"scan-img\">\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3009301624/src/src/app/common/loader-scanning/loader-scanning.component.html
// module id = ../../../../../src/app/common/loader-scanning/loader-scanning.component.html
// module chunks = main